import React from 'react';
import UserService from "../services/UserService";
import {Navigate, Outlet} from 'react-router-dom'


const  ProtectedRoutes=(props:any) =>{

  return UserService.isLoggedIn()?<Outlet/>: <Navigate to="/"/>
}

export default ProtectedRoutes;